import {
  Box, FormControl,
  FormControlLabel,
  Grid, Radio, RadioGroup, Typography
} from "@mui/material";
import SaveResporteStock from "../shared/component/SaveResporteStock";
import { gridSizeMdLg6 } from "@/shared";
import { useReporteStock } from "../shared/hook/useReporteStock";

export default function ReporteStockPage() {

  const hookReporteStock = useReporteStock()

  const {
    opcion,
    handleChangeOpcion
  } = hookReporteStock;

  return (

    <Box
      component={'main'}
      sx={{
        py: 1,
        px: 3
      }}
    >
      <Grid container spacing={3}>
        <Grid item {...gridSizeMdLg6} >
          <Typography variant="h4">
            {"📊 Reporte de Stock Inventariable"}
          </Typography>
        </Grid>

        <Grid item {...gridSizeMdLg6} textAlign={'end'}>

          <FormControl component="fieldset">
            <RadioGroup
              row 
              name="radio-options"
              value={opcion}
              onChange={handleChangeOpcion}
            >
              <FormControlLabel
                value="opcion1"
                control={<Radio />}
                label={<Typography
                  style={{
                    color: '#6C737F',
                  }}
                  variant='subtitle2'>Cargar Stock Actual</Typography>
                }
              />
              <FormControlLabel
                value="opcion2"
                control={<Radio />}
                label={<Typography
                  style={{
                    color: '#6C737F',
                  }}
                  variant='subtitle2'>Cargar Reporte Historico</Typography>
                }
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <SaveResporteStock
            {...hookReporteStock}
          />
        </Grid>
      </Grid>

    </Box>
  )
}